import styled from "@emotion/styled";

import { type BidResponseDto } from "../../../../lib/hooks/api/bid/bid_responses/useBidResponse";
import { Flex } from "../../../../styles/utility-components";
import DetailsForm from "./DetailsForm";

interface BidResponseDetailsSidebarProps {
  bidResponse: BidResponseDto;
  onSourceSelect: (source: BidResponseDto["source"]) => void;
}

export default function BidResponseDetailsSidebar({
  bidResponse,
  onSourceSelect,
}: BidResponseDetailsSidebarProps) {
  return (
    <Container>
      <DetailsForm bidResponse={bidResponse} onSourceSelect={onSourceSelect} />
    </Container>
  );
}

const Container = styled(Flex)({
  flexDirection: "column",
  padding: 24,
  height: "100%",
  overflow: "auto",
});
